import { useRef } from 'react'

const useStableKeys = (length, prefix = 'k') => {
    const seq = useRef(0)
    const keys = useRef([])
    while (keys.current.length < length)
        keys.current.push(`${prefix}${seq.current++}`)
    if (keys.current.length > length) keys.current.length = length
    const removeAt = (i) => {
        if (i >= 0) keys.current.splice(i, 1)
    }
    return [keys.current, removeAt]
}

export default useStableKeys
